import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import axios from "../../node_modules/axios/index";
import Reviews from "../components/Reviews";
import { useDispatch, useSelector } from "react-redux";
import { AuthProvider, useAuth } from "../AuthContext";
import LoadingBox from "../components/LoadingBox";
import Helmet from "../../node_modules/react-helmet/lib/Helmet";
import UserPicture from "../components/UserPicture";
import CreatorList from "../components/CreatorList";
import PopUpFollowers from "../components/PopUpFollowers";
import PopUp from "../components/PopUp";

export default function SearchScreen(props) {
  const dispatch = useDispatch();

  const userId = props.match.params.id;

  const [reviewList, setReviewList] = useState("");
  const [userReviewList, setUserReviewList] = useState("");
  const [followerList, setFollowerList] = useState("");
  const [followingList, setFollowingList] = useState("");

  const [userAlreadyFollow, setUserAlreadyFollow] = useState(false);
  const [loadingFollow, setLoadingFollow] = useState(false);
  const [buttonPopup, setButtonPopup] = useState(false);

  const [userSelected, setUserSelected] = useState("");
  const [toggle, setToggle] = useState("ReviewsAndRating");
  /* const [reviewsLikedIds, setReviewsLikedIds] = useState("");  */
  const [creatorLists, setCreatorLists] = useState("");
  const [popUpFollower, setPopUpFollower] = useState(false);
  const [popUpFollowing, setPopUpFollowing] = useState(false);

  const isMobile = !useMediaQuery({
    query: "(min-width: 652px)",
  });

  useEffect(() => {
    // When a user click on another user in the reviews liked section, we want to send him to the user page in the Reviews and Rating section, not stay in the "Liked reviews" section
    setToggle("ReviewsAndRating");
    window.scrollTo(0, 0);
  }, [userId]);

  const { currentUser } = useAuth();

  const userDetails = useSelector((state) => state.userDetails);
  const { user } = userDetails;

  useEffect(() => {
    async function getReviews(x) {
      let response = await axios.get(
        process.env.REACT_APP_API_ADDRESS +
          `reviews/getreviews/id/all/user/${userId}/order/latest/type/all/moderation/false`
      );
      const reviewListData = response.data;
      setUserReviewList(reviewListData);
      setReviewList(reviewListData);
    }

    async function getUser(x) {
      let response = await axios.get(
        process.env.REACT_APP_API_ADDRESS + `users/user/${userId}`
      );
      const user = response.data;
      setUserSelected(user);
    }

    getReviews();

    getUser(userId);
  }, [userId, dispatch]);

  async function getReviews(x) {
    //getting the liked reviews of the user

    let response = await axios.get(
      process.env.REACT_APP_API_ADDRESS +
        `reviews/getreviews/id/${x}/user/all/order/latest/type/all/moderation/false`
    );
    const reviewListData = response.data;
    setReviewList(reviewListData);
  }
  async function getLikedReviewsIds() {
    // getting the likes of the user

    let response = await axios.get(
      process.env.REACT_APP_API_ADDRESS + `likeReviews/uid/${userSelected.uid}`
    );
    const reviewsliked = Object.values(response.data)
      .map((item) => item.reviewId)
      .join("_");
    if (reviewsliked) {
      getReviews(reviewsliked);
    } else {
      setReviewList("");
    }
  }

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const token = currentUser?.auth.currentUser.accessToken || "";

  const uid = userSelected?.uid;

  useEffect(() => {
    const fetchData = async () => {
      const data = {
        token,
        uid,
      };
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_ADDRESS +
            "creatorlists/getcreatorlists/user",
          data
        );

        setCreatorLists(response.data);

        return response.data; // Return the fetched data
      } catch (error) {
        console.error(
          "Error fetching creator lists:",
          error.response ? error.response.data : error.message
        );

        throw error; // Rethrow or handle error as needed
      }
    };

    async function getFollowers() {
      let allFollowers = await axios.get(
        process.env.REACT_APP_API_ADDRESS +
          `userfollows/followerlist/uid/${userSelected.uid}`
      );

      const listFollowers = allFollowers.data;

      if (
        listFollowers.find((x) => x.uid === currentUser?.auth.currentUser.uid)
      ) {
        setUserAlreadyFollow(true);
      } else setUserAlreadyFollow(false);
      setFollowerList(listFollowers);
    }

    async function getFollowing() {
      let allFollowing = await axios.get(
        process.env.REACT_APP_API_ADDRESS +
          `userfollows/followinglist/uid/${userSelected.uid}`
      );

      const listFollowing = allFollowing.data;

      setFollowingList(listFollowing);
    }

    if (userSelected?.uid) {
      fetchData();
      getFollowers();
      getFollowing();
    }
  }, [userSelected, userAlreadyFollow]);

  const followTheUser = async () => {
    setLoadingFollow(true);
    try {
      const followedUid = userSelected.uid;
      const followedId = userId;
      const followerId = user.userId;

      const response = await axios.post(
        process.env.REACT_APP_API_ADDRESS + `userfollows/addFollow`,
        { token, followedUid, followedId, followerId }
      );
      setUserAlreadyFollow(true);
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching creator lists:",
        error.response ? error.response.data : error.message
      );
    } finally {
      setLoadingFollow(false);
    }
  };

  const unfollowTheUser = async () => {
    setLoadingFollow(true);

    try {
      const followedUid = userSelected.uid;

      const response = await axios.delete(
        process.env.REACT_APP_API_ADDRESS + `userfollows/unfollow`,
        { data: { token, followedUid } }
      );
      setUserAlreadyFollow(false);
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching creator lists:",
        error.response ? error.response.data : error.message
      );
    } finally {
      setLoadingFollow(false);
    }
  };

  return (
    <div className="profileUser">
      <Helmet>
        <title>
          {userSelected
            ? userSelected.userName + "'s profile | Favoree"
            : "User profile | Favoree"}
        </title>
        <meta
          name="description"
          content={
            userSelected && userReviewList
              ? userSelected.userName +
                " uses Favoree to share channel reviews and ratings. " +
                userReviewList.length +
                " channels reviewed. Member since " +
                userSelected.creationDate.substring(0, 4) +
                "."
              : "Channel reviews written by this user."
          }
        ></meta>
        <link
          rel="canonical"
          href={"https://www.favoree.io" + props.match.url}
        ></link>
      </Helmet>
      {!userSelected ? (
        <div className="mainElement">
          {" "}
          <div className="space"></div>
          <div className="space"></div>
          <div className="space"></div>
          <div className="space"></div>
          <LoadingBox></LoadingBox>
        </div>
      ) : (
        <div>
          <div className="space"></div>
          <div className="space"></div>

          <div className="mainElement">
            <div
              className="row top"
              id="coverReviews"
              style={{ "max-width": "120rem", margin: "auto" }}
            >
              <div className="alignHorizontal" id="profile">
                {!isMobile && (
                  <UserPicture
                    uid={userSelected?.uid}
                    imageSize="avatarPictureMedium"
                  ></UserPicture>
                )}

                <div
                  className="verticalAlign"
                  id="profileDescription"
                  style={
                    isMobile
                      ? {}
                      : { "margin-left": "2rem", "margin-right": "2rem" }
                  }
                >
                  <div className="alignHorizontal" id="profile">
                    {isMobile && (
                      <div style={{ width: "30%" }}>
                        <UserPicture
                          uid={userSelected?.uid}
                          imageSize="adaptScreen"
                        ></UserPicture>
                      </div>
                    )}
                    <div
                      style={
                        isMobile
                          ? {
                              width: "69%",
                            }
                          : {
                              display: "flex",
                              "flex-wrap": "wrap",
                            }
                      }
                    >
                      <h2 id="italic">{userSelected.userName}</h2>{" "}
                      {userReviewList && isMobile && (
                        <div className="alignHorizontal" id="alignText">
                          <text style={{ "font-style": "italic" }}>
                            Member since{" "}
                            {userSelected.creationDate &&
                              monthNames[
                                userSelected.creationDate.substring(5, 7) - 1
                              ]}{" "}
                            {userSelected.creationDate &&
                              userSelected.creationDate.substring(0, 4)}
                          </text>{" "}
                        </div>
                      )}
                      <div className="space"></div>
                      <div className="space"></div>
                      {userId && user && userId == user.userId ? (
                        <a href="/settings">
                          {" "}
                          <button id="transparentButton">
                            <i className="fa-solid fa-pen-to-square"></i> Edit
                            profile
                          </button>
                        </a>
                      ) : (
                        <div
                          style={{
                            "margin-bottom": "0rem",
                            "margin-top": "auto",
                          }}
                        >
                          {loadingFollow ? (
                            <div
                              style={{
                                height: "3.8rem",
                              }}
                            >
                              <LoadingBox></LoadingBox>
                            </div>
                          ) : !userAlreadyFollow ? (
                            <button
                              onClick={() => {
                                if (user?.userId) {
                                  followTheUser();
                                } else {
                                  setButtonPopup(true);
                                }
                              }}
                              style={{
                                "background-color": "#0693e3",
                              }}
                              id="hoverOpacity"
                            >
                              <i class="fa-solid fa-user-plus"></i>&nbsp; Follow
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                unfollowTheUser();
                              }}
                              style={{
                                "background-color": "#4c5866",
                              }}
                              id="hoverOpacity"
                            >
                              <i class="fa-solid fa-user-minus"></i> Unfollow
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {userReviewList && !isMobile && (
                    <div className="alignHorizontal" id="alignText">
                      <text style={{ "font-style": "italic" }}>
                        Member since{" "}
                        {userSelected.creationDate &&
                          monthNames[
                            userSelected.creationDate.substring(5, 7) - 1
                          ]}{" "}
                        {userSelected.creationDate &&
                          userSelected.creationDate.substring(0, 4)}
                      </text>{" "}
                    </div>
                  )}
                  <div className="space"> </div>
                  <div className="space"> </div>
                  {userSelected.description &&
                  userSelected.description !== " " ? (
                    <div>
                      <p>{userSelected.description}</p>
                    </div>
                  ) : (
                    <div> </div>
                  )}
                  <div className="alignHorizontal" id="profile">
                    {userSelected.youtube && (
                      <a
                        target="_blank"
                        href={"https://www.youtube.com/" + userSelected.youtube}
                      >
                        <strong className="youTubeColor">
                          <i className="fa-brands fa-youtube"></i>
                          {" " + userSelected.youtube.substring(1)}
                        </strong>
                      </a>
                    )}
                    {userSelected.youtube && (
                      <div>
                        {" "}
                        <div className="space"></div>
                        <div className="space"></div>{" "}
                      </div>
                    )}

                    {userSelected.twitter && (
                      <a
                        target="_blank"
                        href={
                          "https://twitter.com/" +
                          userSelected.twitter.replace("@", "")
                        }
                      >
                        <strong className="twitterColor">
                          <i className="fa-brands fa-twitter"></i>
                          {" " + userSelected.twitter.substring(1)}
                        </strong>
                      </a>
                    )}
                  </div>
                </div>
              </div>

              <div id="userInfo">
                {userReviewList && userReviewList.length > 0 && (
                  <div className="alignHorizontal" id="alignText">
                    <h3>
                      {(
                        userReviewList
                          .map((review) => review.rating)
                          .reduce((prev, next) => prev + next) /
                        userReviewList.length
                      ).toFixed(1)}{" "}
                    </h3>
                    <i className="fa-solid fa-star"></i>
                    <div className="space"></div>
                    <text> average rating </text>
                  </div>
                )}
                {userReviewList && (
                  <div className="alignHorizontal" id="alignText">
                    <h3>{userReviewList.length} </h3>{" "}
                    <div className="space"></div>{" "}
                    <text> review{userReviewList.length < 1 ? "" : "s"} </text>
                  </div>
                )}

                {followerList && (
                  <div
                    className="alignHorizontal hoverMouse"
                    id="alignText"
                    onClick={() => {
                      setPopUpFollower(true);
                    }}
                  >
                    <h3>{followerList.length}</h3> <div className="space"></div>
                    <text style={{ "font-weight": "800" }}>
                      {" "}
                      follower{followerList?.length > 1 && "s"}{" "}
                    </text>{" "}
                  </div>
                )}
                {followingList && (
                  <div
                    className="alignHorizontal hoverMouse"
                    id="alignText"
                    onClick={() => {
                      setPopUpFollowing(true);
                    }}
                  >
                    <h3>{followingList.length}</h3>{" "}
                    <div className="space"></div>
                    <text style={{ "font-weight": "800" }}>
                      {" "}
                      following{followingList?.length > 1 && "s"}
                    </text>{" "}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="space"></div>
          <div className="space"></div>

          <div className="space"></div>

          <div className="hr-line">
            <hr></hr>
          </div>
          <div className="space"></div>
          <div className="space"></div>
          <div className="space"></div>

          <div className="mainElement">
            {userReviewList && (
              <div className="alignHorizontal" id="toRight">
                <div className="filterSlider">
                  <ul class="ulFilter">
                    {" "}
                    <button
                      className="sortVideos"
                      id={
                        toggle == "ReviewsAndRating" ? "sortVideosOn" : "other"
                      }
                      onClick={() => {
                        setToggle("ReviewsAndRating");
                        setReviewList(userReviewList);
                      }}
                    >
                      <p>
                        {" "}
                        <i className="fa-solid fa-star"></i> All ratings{" "}
                      </p>
                    </button>
                    {userReviewList.length > 9 && (
                      <button
                        className="sortVideos"
                        id={toggle == "ReviewsOnly" ? "sortVideosOn" : "other"}
                        onClick={() => {
                          setToggle("ReviewsOnly");
                          setReviewList(
                            userReviewList.filter(
                              (review) => review.comment.length >= 1
                            )
                          );
                        }}
                      >
                        <p>
                          <i class="fa-solid fa-comments"></i> Reviews only{" "}
                        </p>
                      </button>
                    )}
                    <button
                      className="sortVideos"
                      id={toggle == "creatorList" ? "sortVideosOn" : "other"}
                      onClick={() => {
                        setToggle("creatorList");
                      }}
                    >
                      <p>
                        {" "}
                        <i class="fa-solid fa-list-ol"></i> Channel lists{" "}
                      </p>
                    </button>
                    <button
                      className="sortVideos"
                      id={
                        toggle == "OtherUsersReviews" ? "sortVideosOn" : "other"
                      }
                      onClick={() => {
                        setToggle("OtherUsersReviews");
                        getLikedReviewsIds();
                      }}
                    >
                      <p>
                        {" "}
                        <i className="fa-solid fa-heart"></i> Liked reviews{" "}
                      </p>
                    </button>
                  </ul>
                </div>
              </div>
            )}

            {reviewList.length <= 9 && (
              <div>
                {" "}
                <div className="space"> </div> <div className="space"> </div>
              </div>
            )}
            <div className="space"></div>
            <div className="space"></div>
            <div className="space"></div>

            <div className="row top" id="coverReviews">
              {reviewList &&
              reviewList.length > 0 &&
              toggle !== "creatorList" ? (
                <Reviews
                  reviewList={reviewList}
                  currentUser={currentUser}
                  reviewRemoval={true}
                ></Reviews>
              ) : toggle !== "creatorList" ? (
                <div id="leftAlign">
                  <text>
                    {toggle == "OtherUsersReviews"
                      ? "This user hasn't liked any review for now"
                      : "This user hasn't reviewed a channel for now"}
                  </text>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                </div>
              ) : (
                <div></div>
              )}
            </div>

            {creatorLists?.length > 0 && toggle == "creatorList" ? (
              <div className="row top">
                {creatorLists.map((c) => (
                  <div id={c._id}>
                    <CreatorList
                      name={c.listName}
                      list={c.list}
                      description={c.description}
                      uid={c.uid}
                      _id={c._id}
                    ></CreatorList>
                  </div>
                ))}
              </div>
            ) : toggle == "creatorList" ? (
              <div className="row top" id="coverReviews">
                <div id="leftAlign">
                  <text>
                    This user has not created any YouTube channel list
                  </text>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                  <div className="space"></div>
                </div>
              </div>
            ) : (
              <div></div>
            )}
            <div className="space"></div>
            <div className="space"></div>
          </div>
        </div>
      )}
      <div className="space"></div>
      <div className="space"></div>
      <div className="space"></div>
      <div className="space"></div>
      <div className="space"></div>
      <div className="space"></div>
      <div className="cover" id="thrdColor">
        <div className="coverInside">
          <div className="twoThird">
            <h4>Can't find your favorite channel?</h4>
            <div className="space"></div>

            <a className="buttonLightGrey" id="darkBlue" href="/add-channel">
              {" "}
              Add new channel
            </a>
          </div>
          {useMediaQuery({
            query: "(min-width: 952px)",
          }) && (
            <div className="oneThird">
              <img
                className="headerPicture"
                src="/images/addChannel.png"
                alt="add a Channel"
              ></img>
            </div>
          )}
        </div>
      </div>
      {popUpFollower && userSelected && followerList && (
        <PopUpFollowers
          title={userSelected.userName + "'s followers"}
          setPopUpFollow={setPopUpFollower}
          popUpFollow={popUpFollower}
          userName={userSelected.userName}
          followList={followerList}
        ></PopUpFollowers>
      )}
      {popUpFollowing && userSelected && followingList && (
        <PopUpFollowers
          title={"Followed by " + userSelected.userName}
          setPopUpFollow={setPopUpFollowing}
          popUpFollow={popUpFollowing}
          userName={userSelected.userName}
          followList={followingList}
        ></PopUpFollowers>
      )}
      <PopUp trigger={buttonPopup} setTrigger={setButtonPopup}></PopUp>
      <div className="space"></div>
      <div className="space"></div>
      <div className="space"></div>
    </div>
  );
}
